import { DiscordSDK } from '@discord/embedded-app-sdk';
import { DANS_DISCORD } from '../api/client';

const CLIENT_ID = import.meta.env.VITE_DISCORD_CLIENT_ID;

/**
 * Le SDK Discord, ou son sosie quand on développe au navigateur.
 *
 * Sans doublure, chaque changement d'une ligne obligerait à fermer et rouvrir
 * l'Activity dans Discord — il n'y a pas de rechargement à chaud dans l'iframe.
 * Le sosie rend le développement ordinaire : on recharge la page et on voit.
 *
 * Il ment sur une seule chose, l'identité de la personne, parce que c'est la
 * seule que Discord peut donner. Tout le reste — API, catalogue, lecture — est
 * bien réel : le proxy de Vite parle au vrai site.
 */

const SOSIE = {
  estUnSosie: true,
  // Une instance par salon vocal ; ici une valeur stable, pour que deux
  // onglets ouverts côte à côte se retrouvent dans la même « séance ».
  instanceId: 'sosie-instance-locale',
  channelId: 'sosie-salon',
  guildId: 'sosie-serveur',
  async ready() {},
  commands: {
    async authorize() {
      return { code: 'sosie' };
    },
    async authenticate() {
      return { user: { id: 'sosie', username: 'developpeur' } };
    },
    async setActivity() {},
  },
};

let instance = null;

export async function obtenirSdk() {
  if (instance) return instance;

  if (!DANS_DISCORD) {
    instance = SOSIE;
    return instance;
  }

  if (!CLIENT_ID) {
    throw new Error('VITE_DISCORD_CLIENT_ID manquant dans activity/.env');
  }

  const sdk = new DiscordSDK(CLIENT_ID);
  // `ready()` lève l'écran de chargement de Discord : sans lui, il reste posé
  // par-dessus la page et on ne voit jamais rien.
  await sdk.ready();

  instance = sdk;
  return instance;
}

export { CLIENT_ID };
